import styled from 'styled-components';
import { ColorPalettes, Button } from 'kinedu-react-components';

const { KineduPalette } = ColorPalettes;

const MainButton = styled(Button).attrs(() => ({
  color: 'primary',
  small: true,
  flat: true,
  rounded: true,
}))`
  font-size: 18px;
`;

const Title = styled.span`
  color: ${KineduPalette.oldkinedu};
  margin: 30px 0 10px;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
`;

const Subtitle = styled.p`
  color: ${KineduPalette.shadeMediumDark};
  margin: 10px 0 20px;
  font-size: 16px;
  text-align: center;
`;

const InputGroup = styled.div`
  & > * {
    margin-bottom: 20px;
  }
`;

const ErrorMessage = styled.p`
  color: #ff0039;
  font-size: 0.7rem;
  padding: 10px 0px;
  margin: -20px 0 0;
  text-transform: initial;

  &::first-letter {
    text-transform: uppercase;
  }
`;

export {
  MainButton,
  Title,
  Subtitle,
  InputGroup,
  ErrorMessage,
};
